// userSelectors.js

export const selectLoading = (state) => state.selectLocation.loading;
export const selectAppointmentSuccessData = (state) => state.selectLocation.appointmentSuccessData;
export const selectpaymentData = (state) => state.selectLocation.paymentData;



